var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1836,
    height: 400,
    viewBox: "0 0 1836 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d5d5d5;}.b{fill:url(#a);}.c,.g{fill:#fff;}.d{fill:#5b5b5b;}.e{clip-path:url(#b);}.f{clip-path:url(#c);}.g{font-size:76px;font-family:SegoeUI, Segoe UI;opacity:0.93;}.h{fill:#b02318;}.i{clip-path:url(#d);}.j{fill:#ffbcbc;}.k{fill:none;stroke:#ee5050;stroke-width:0.87px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.991,
    y1: 0.411,
    x2: 0,
    y2: 0.395,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee5050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb4b4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1836,
    height: 397.308
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1836,
    height: 397
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 555,
    height: 400,
    transform: "translate(0.449)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -105)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 107.393)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 1836,
    height: 397,
    transform: "translate(0 0.607)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,0H1836V397.308H0Z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "g",
    transform: "translate(538 222.607)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -344.134,
    y: 0
  }, "Welcome to Sen"), /*#__PURE__*/React.createElement("tspan", {
    className: "h",
    y: 0
  }, "db"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "iz"))), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(1152.55 105)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.537 -21.423)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 179.578)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(274.241 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,0l16.7,29.234-16.7,29.234H16.7L0,29.234,16.7,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 29.234, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x2: 15.313,
    y2: 8.352,
    transform: "translate(28.238 30.19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y2: 6.96,
    transform: "translate(43.551 31.582)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y2: 18.097,
    transform: "translate(43.551 38.542)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(343.843 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,0l16.7,29.234-16.7,29.234H16.7L0,29.234,16.7,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 29.234, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x2: 15.313,
    y2: 8.352,
    transform: "translate(28.238 30.19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y2: 6.96,
    transform: "translate(43.551 31.582)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y2: 18.097,
    transform: "translate(43.551 38.542)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.604 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,0l16.7,29.234-16.7,29.234H16.7L0,29.234,16.7,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 29.234, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x2: 15.313,
    y2: 8.352,
    transform: "translate(28.238 30.19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y2: 6.96,
    transform: "translate(43.551 31.582)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y2: 18.097,
    transform: "translate(43.551 38.542)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,0l16.7,29.234-16.7,29.234H16.7L0,29.234,16.7,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 29.234, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x2: 15.313,
    y2: 8.352,
    transform: "translate(28.238 30.19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y2: 6.96,
    transform: "translate(43.551 31.582)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y2: 18.097,
    transform: "translate(43.551 38.542)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(137.814 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,0l16.7,29.234-16.7,29.234H16.7L0,29.234,16.7,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 29.234, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x2: 15.313,
    y2: 8.352,
    transform: "translate(28.238 30.19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y2: 6.96,
    transform: "translate(43.551 31.582)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y2: 18.097,
    transform: "translate(43.551 38.542)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(206.029 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,0l16.7,29.234-16.7,29.234H16.7L0,29.234,16.7,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 29.234, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x2: 15.313,
    y2: 8.352,
    transform: "translate(28.238 30.19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y2: 6.96,
    transform: "translate(43.551 31.582)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y2: 18.097,
    transform: "translate(43.551 38.542)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.018 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.212)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(208.812 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,0l16.7,29.234-16.7,29.234H16.7L0,29.234,16.7,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 29.234, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x2: 15.313,
    y2: 8.352,
    transform: "translate(28.238 30.19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y2: 6.96,
    transform: "translate(43.551 31.582)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y2: 18.097,
    transform: "translate(43.551 38.542)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.604 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,0l16.7,29.234-16.7,29.234H16.7L0,29.234,16.7,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 29.234, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x2: 15.313,
    y2: 8.352,
    transform: "translate(28.238 30.19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y2: 6.96,
    transform: "translate(43.551 31.582)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y2: 18.097,
    transform: "translate(43.551 38.542)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,0l16.7,29.234-16.7,29.234H16.7L0,29.234,16.7,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 29.234, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x2: 15.313,
    y2: 8.352,
    transform: "translate(28.238 30.19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y2: 6.96,
    transform: "translate(43.551 31.582)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y2: 18.097,
    transform: "translate(43.551 38.542)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(277.023 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,0l16.7,29.234-16.7,29.234H16.7L0,29.234,16.7,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 29.234, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x2: 15.313,
    y2: 8.352,
    transform: "translate(28.238 30.19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y2: 6.96,
    transform: "translate(43.551 31.582)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y2: 18.097,
    transform: "translate(43.551 38.542)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(139.208 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,0l16.7,29.234-16.7,29.234H16.7L0,29.234,16.7,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 29.234, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x2: 15.313,
    y2: 8.352,
    transform: "translate(28.238 30.19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y2: 6.96,
    transform: "translate(43.551 31.582)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y2: 18.097,
    transform: "translate(43.551 38.542)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(346.627 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,0l16.7,29.234-16.7,29.234H16.7L0,29.234,16.7,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 29.234, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x2: 15.313,
    y2: 8.352,
    transform: "translate(28.238 30.19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y2: 6.96,
    transform: "translate(43.551 31.582)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y2: 18.097,
    transform: "translate(43.551 38.542)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.41 61.251)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(207.418 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,0l16.7,29.234-16.7,29.234H16.7L0,29.234,16.7,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 29.234, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x2: 15.313,
    y2: 8.352,
    transform: "translate(28.238 30.19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y2: 6.96,
    transform: "translate(43.551 31.582)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y2: 18.097,
    transform: "translate(43.551 38.542)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(277.023 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,0l16.7,29.234-16.7,29.234H16.7L0,29.234,16.7,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 29.234, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x2: 15.313,
    y2: 8.352,
    transform: "translate(28.238 30.19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y2: 6.96,
    transform: "translate(43.551 31.582)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y2: 18.097,
    transform: "translate(43.551 38.542)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(345.235 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,0l16.7,29.234-16.7,29.234H16.7L0,29.234,16.7,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 29.234, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x2: 15.313,
    y2: 8.352,
    transform: "translate(28.238 30.19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y2: 6.96,
    transform: "translate(43.551 31.582)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y2: 18.097,
    transform: "translate(43.551 38.542)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.605 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,0l16.7,29.234-16.7,29.234H16.7L0,29.234,16.7,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 29.234, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x2: 15.313,
    y2: 8.352,
    transform: "translate(28.238 30.19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y2: 6.96,
    transform: "translate(43.551 31.582)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y2: 18.097,
    transform: "translate(43.551 38.542)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,0l16.7,29.234-16.7,29.234H16.7L0,29.234,16.7,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 29.234, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x2: 15.313,
    y2: 8.352,
    transform: "translate(28.238 30.19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y2: 6.96,
    transform: "translate(43.551 31.582)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y2: 18.097,
    transform: "translate(43.551 38.542)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(139.209 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,0l16.7,29.234-16.7,29.234H16.7L0,29.234,16.7,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 29.234, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x2: 15.313,
    y2: 8.352,
    transform: "translate(28.238 30.19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y2: 6.96,
    transform: "translate(43.551 31.582)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y2: 18.097,
    transform: "translate(43.551 38.542)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 121.023)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(275.631 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,0l16.7,29.234-16.7,29.234H16.7L0,29.234,16.7,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 29.234, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x2: 15.313,
    y2: 8.352,
    transform: "translate(28.238 30.19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y2: 6.96,
    transform: "translate(43.551 31.582)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y2: 18.097,
    transform: "translate(43.551 38.542)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(345.235 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,0l16.7,29.234-16.7,29.234H16.7L0,29.234,16.7,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 29.234, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x2: 15.313,
    y2: 8.352,
    transform: "translate(28.238 30.19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y2: 6.96,
    transform: "translate(43.551 31.582)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y2: 18.097,
    transform: "translate(43.551 38.542)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.605 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,0l16.7,29.234-16.7,29.234H16.7L0,29.234,16.7,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 29.234, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x2: 15.313,
    y2: 8.352,
    transform: "translate(28.238 30.19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y2: 6.96,
    transform: "translate(43.551 31.582)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y2: 18.097,
    transform: "translate(43.551 38.542)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,0l16.7,29.234-16.7,29.234H16.7L0,29.234,16.7,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 29.234, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x2: 15.313,
    y2: 8.352,
    transform: "translate(28.238 30.19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y2: 6.96,
    transform: "translate(43.551 31.582)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y2: 18.097,
    transform: "translate(43.551 38.542)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(137.817 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,0l16.7,29.234-16.7,29.234H16.7L0,29.234,16.7,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 29.234, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x2: 15.313,
    y2: 8.352,
    transform: "translate(28.238 30.19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y2: 6.96,
    transform: "translate(43.551 31.582)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y2: 18.097,
    transform: "translate(43.551 38.542)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(207.418 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,0l16.7,29.234-16.7,29.234H16.7L0,29.234,16.7,0Z",
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 29.234, 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x2: 15.313,
    y2: 8.352,
    transform: "translate(28.238 30.19)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y2: 6.96,
    transform: "translate(43.551 31.582)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y2: 18.097,
    transform: "translate(43.551 38.542)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.018 238.044)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.212 121.024)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(208.812 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,58.467l16.7-29.234L50.115,0H16.7L0,29.234,16.7,58.467Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 33.41)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 8.352,
    x2: 15.313,
    transform: "translate(28.238 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y1: 6.96,
    transform: "translate(43.551 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 18.097,
    transform: "translate(43.551 27.404)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.604 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,58.467l16.7-29.234L50.115,0H16.7L0,29.234,16.7,58.467Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 33.41)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 8.352,
    x2: 15.313,
    transform: "translate(28.238 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y1: 6.96,
    transform: "translate(43.551 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 18.097,
    transform: "translate(43.551 27.404)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,58.467l16.7-29.234L50.115,0H16.7L0,29.234,16.7,58.467Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 33.41)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 8.352,
    x2: 15.313,
    transform: "translate(28.238 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y1: 6.96,
    transform: "translate(43.551 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 18.097,
    transform: "translate(43.551 27.404)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(277.023 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,58.467l16.7-29.234L50.115,0H16.7L0,29.234,16.7,58.467Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 33.41)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 8.352,
    x2: 15.313,
    transform: "translate(28.238 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y1: 6.96,
    transform: "translate(43.551 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 18.097,
    transform: "translate(43.551 27.404)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(139.208 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,58.467l16.7-29.234L50.115,0H16.7L0,29.234,16.7,58.467Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 33.41)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 8.352,
    x2: 15.313,
    transform: "translate(28.238 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y1: 6.96,
    transform: "translate(43.551 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 18.097,
    transform: "translate(43.551 27.404)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(346.626 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,58.467l16.7-29.234L50.115,0H16.7L0,29.234,16.7,58.467Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 33.41)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 8.352,
    x2: 15.313,
    transform: "translate(28.238 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y1: 6.96,
    transform: "translate(43.551 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 18.097,
    transform: "translate(43.551 27.404)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.41 59.773)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(207.418 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,58.467l16.7-29.234L50.115,0H16.7L0,29.234,16.7,58.467Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 33.41)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 8.352,
    x2: 15.313,
    transform: "translate(28.238 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y1: 6.96,
    transform: "translate(43.551 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 18.097,
    transform: "translate(43.551 27.404)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(277.022 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,58.467l16.7-29.234L50.115,0H16.7L0,29.234,16.7,58.467Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 33.41)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 8.352,
    x2: 15.313,
    transform: "translate(28.238 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y1: 6.96,
    transform: "translate(43.551 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 18.097,
    transform: "translate(43.551 27.404)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(345.234 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,58.467l16.7-29.234L50.115,0H16.7L0,29.234,16.7,58.467Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 33.41)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 8.352,
    x2: 15.313,
    transform: "translate(28.238 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y1: 6.96,
    transform: "translate(43.551 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 18.097,
    transform: "translate(43.551 27.404)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.604 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,58.467l16.7-29.234L50.115,0H16.7L0,29.234,16.7,58.467Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 33.41)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 8.352,
    x2: 15.313,
    transform: "translate(28.238 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y1: 6.96,
    transform: "translate(43.551 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 18.097,
    transform: "translate(43.551 27.404)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,58.467l16.7-29.234L50.115,0H16.7L0,29.234,16.7,58.467Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 33.41)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 8.352,
    x2: 15.313,
    transform: "translate(28.238 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y1: 6.96,
    transform: "translate(43.551 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 18.097,
    transform: "translate(43.551 27.404)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(139.209 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,58.467l16.7-29.234L50.115,0H16.7L0,29.234,16.7,58.467Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 33.41)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 8.352,
    x2: 15.313,
    transform: "translate(28.238 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y1: 6.96,
    transform: "translate(43.551 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 18.097,
    transform: "translate(43.551 27.404)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(275.63)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,58.467l16.7-29.234L50.115,0H16.7L0,29.234,16.7,58.467Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 33.41)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 8.352,
    x2: 15.313,
    transform: "translate(28.238 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y1: 6.96,
    transform: "translate(43.551 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 18.097,
    transform: "translate(43.551 27.404)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(345.234)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,58.467l16.7-29.234L50.115,0H16.7L0,29.234,16.7,58.467Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 33.41)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 8.352,
    x2: 15.313,
    transform: "translate(28.238 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y1: 6.96,
    transform: "translate(43.551 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 18.097,
    transform: "translate(43.551 27.404)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.604)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,58.467l16.7-29.234L50.115,0H16.7L0,29.234,16.7,58.467Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 33.41)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 8.352,
    x2: 15.313,
    transform: "translate(28.238 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y1: 6.96,
    transform: "translate(43.551 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 18.097,
    transform: "translate(43.551 27.404)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,58.467l16.7-29.234L50.115,0H16.7L0,29.234,16.7,58.467Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 33.41)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 8.352,
    x2: 15.313,
    transform: "translate(28.238 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y1: 6.96,
    transform: "translate(43.551 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 18.097,
    transform: "translate(43.551 27.404)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(137.817)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,58.467l16.7-29.234L50.115,0H16.7L0,29.234,16.7,58.467Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 33.41)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 8.352,
    x2: 15.313,
    transform: "translate(28.238 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y1: 6.96,
    transform: "translate(43.551 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 18.097,
    transform: "translate(43.551 27.404)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(207.418)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M50.115,58.467l16.7-29.234L50.115,0H16.7L0,29.234,16.7,58.467Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 0, 33.41)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 8.352,
    x2: 15.313,
    transform: "translate(28.238 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 15.313,
    y1: 6.96,
    transform: "translate(43.551 45.501)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    y1: 18.097,
    transform: "translate(43.551 27.404)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCompany);
export default __webpack_public_path__ + "static/media/edit-company.e71754ac528e09fd0132324762c04ed3.svg";
export { ForwardRef as ReactComponent };